import { render } from "./TeamReportDescriptionPage.vue?vue&type=template&id=6e154966&scoped=true"
import script from "./TeamReportDescriptionPage.vue?vue&type=script&lang=js"
export * from "./TeamReportDescriptionPage.vue?vue&type=script&lang=js"

import "./TeamReportDescriptionPage.vue?vue&type=style&index=0&id=6e154966&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e154966"]])

export default __exports__